import { HttpClient } from '@angular/common/http';
import {
    mergeDeep,
    TranslateLoader,
    TranslationObject,
} from '@ngx-translate/core';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

export class MultiTranslateHttpLoader implements TranslateLoader {
    static translateLoaded = false;
    constructor(
        private http: HttpClient,
        public resources: {
            prefix: string;
            suffix: string;
            dynamic?: boolean;
        }[],
    ) {}

    public getTranslation(lang: string): Observable<TranslationObject> {
        return forkJoin(
            this.resources.map((config) =>
                this.http
                    .get<TranslationObject>(
                        `${config.prefix}${lang}${config.suffix}`,
                    )
                    .pipe(
                        catchError((error: unknown) =>
                            config.dynamic ? of(null) : throwError(() => error),
                        ),
                    ),
            ),
        ).pipe(
            finalize(() => (MultiTranslateHttpLoader.translateLoaded = true)),
            map((bundles) =>
                bundles.reduce<TranslationObject>(
                    (merged, bundle) =>
                        bundle
                            ? (mergeDeep(merged, bundle) as TranslationObject)
                            : merged,
                    {},
                ),
            ),
        );
    }
}
